import { render, staticRenderFns } from "./LabelTag.vue?vue&type=template&id=7d62918e&scoped=true&"
import script from "./LabelTag.vue?vue&type=script&lang=js&"
export * from "./LabelTag.vue?vue&type=script&lang=js&"
import style0 from "./LabelTag.vue?vue&type=style&index=0&id=7d62918e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62918e",
  null
  
)

export default component.exports